import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-system-resources';
@Injectable({
  providedIn: 'root'
})
export class SystemService {

  constructor(private fabricService: FabricService) {

  }

  getSystem(): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_system');
  }
}
